import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import UserCard from './UserCard';
import Searchfilter from './Searchfilter';
import './Search.css';
import * as Actions from '../../actions/actions';

const isGender = (user, gender) => user.gender === gender;
const hasImage = user => !!user.photoURL;
const olderThan = (user, age) =>
  new Date(user.birthday) < new Date().setFullYear(-age);
const houseSituation = (user, type) => user.houseSituation === type;
const isLowerThanRange = (user, range) => user.distance <= range;

const filterMap = new Map([
  ['male', user => isGender(user, 'male')],
  ['female', user => isGender(user, 'female')],
  ['hasImage', user => hasImage(user)],
  ['>=20', user => olderThan(user, 20)],
  ['landscape', user => houseSituation(user, 'landscape')],
  ['city', user => houseSituation(user, 'city')],
  ['5km', user => isLowerThanRange(user, 5)],
  ['10km', user => isLowerThanRange(user, 10)],
  ['25km', user => isLowerThanRange(user, 25)],
  ['50km', user => isLowerThanRange(user, 50)]
]);

class Search extends Component {
  constructor(props) {
    super(props);
    const { search, currentUserVm: { place } } = props;
    if (place) {
      search(50);
    }
  }

  render() {
    const {
      authVm: { uid },
      searchVm: { result, filterValues },
    } = this.props;
    return (
      <div className="search">
        <section className="petOverview">
          <h1>Filter</h1>
          <Searchfilter />
        </section>
        <div>
          <h1>Mein neuer Pate</h1>
          {Array.from(result.entries())
            .filter(([key, value]) => key !== uid && Array.from(filterValues).every(x => filterMap.get(x)(value)))
            .map(([key, value]) => <UserCard key={key} id={key} {...value} />)}
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({ ...state.searchReducer, ...state.authReducer, ...state.currentUserReducer }),
  dispatch => bindActionCreators(Actions, dispatch)
)(Search);



// WEBPACK FOOTER //
// ./src/pages/Search/index.js